// extracted by mini-css-extract-plugin
export default {"hero2":"Hero2_hero2__GAOry","hero2Section":"Hero2_hero2Section__gQLrl"};